import useAsyncTask from './useAsyncTask';
import useToaster from './useToaster';

export default function ({ errorParser, taskname = 'default' }) {
  const [errorCatcher] = useAsyncTask(taskname, useToaster(errorParser));
  return [useToaster(), errorCatcher];
}
